import { getScheduleShiftCodeFontSize } from "@utils/fontSizeUtils";
import { cn } from "@utils/cn.ts";
import ShiftCode from "@/components/shift/ShiftCode";
import { useRosterFocusStore } from "@/store/rosterFocusStore";
import AssignmentGroupBar from "@/pages/roster-create/components/shift-code/assignment-group-bar";
import type { AssignmentStartInfo } from "@/services/assignment";

const EMPTY_SHIFT_CELL_BG = "#F0F0F2";

function TdShiftCodeButtonView({
  day,
  shift,
  isEveryFifth,
  prefix = "",
  nurseId = "",
  nursesIndex = 0,
  assignmentStart = null,
}: {
  day: number;
  shift:
    | {
        shift_id: string;
        name: string;
        color: string;
        default_shift?: string;
        shift_gb?: string;
      }
    | undefined;
  isEveryFifth?: boolean;
  prefix?: string;
  nurseId?: string;
  nursesIndex?: number;
  /** 기간배정(병동이동 등) — 시작 셀에서만 */
  assignmentStart?: AssignmentStartInfo | null;
}) {
  void isEveryFifth;
  const columnKey = `${prefix}day${day}`;
  const displayShiftId = shift?.shift_id ?? "-";
  const fontSize = getScheduleShiftCodeFontSize(displayShiftId);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);
  const setSelectedFocus = useRosterFocusStore((s) => s.setSelectedFocus);
  const clearSelectedFocus = useRosterFocusStore((s) => s.clearSelectedFocus);

  const shiftBgColor = shift?.color ?? EMPTY_SHIFT_CELL_BG;

  const handleCellMouseEnter = () => {
    setHoveredFocus({ column: columnKey, nurseId: String(nurseId) });
  };
  const handleCellMouseLeave = () => {
    clearHoveredFocus();
  };

  return (
    <div data-column={columnKey}>
      <div
        className="p-[3px] relative flex items-center"
        data-roster-shift-cell=""
      >
        {assignmentStart && (
          <AssignmentGroupBar
            key={`${nursesIndex}-${day}-asgn-${assignmentStart.reason}-${assignmentStart.startDay}`}
            group={assignmentStart}
          />
        )}
        <div className={cn("d-f jc-c ai-c h-100p ")}>
          <button
            type="button"
            title={shift?.name ?? "미배정"}
            data-nurse-id={String(nurseId)}
            data-day={day}
            data-shift-id={shift?.shift_id ?? displayShiftId}
            data-default-shift={shift?.default_shift ?? ""}
            data-shift-gb={shift?.shift_gb ?? ""}
            style={{ fontSize }}
            onMouseEnter={handleCellMouseEnter}
            onMouseLeave={handleCellMouseLeave}
            onClick={(e) => {
              e.stopPropagation();
              const nid = String(nurseId);
              const st = useRosterFocusStore.getState();
              if (
                st.selectedColumn === columnKey &&
                st.selectedNurseId === nid
              ) {
                clearSelectedFocus();
              } else {
                setSelectedFocus({
                  column: columnKey,
                  nurseId: nid,
                });
              }
            }}
          >
            <ShiftCode code={displayShiftId} color={shiftBgColor} />
          </button>
          <div className="errorShift">
            <div className="errorBadge"></div>
            <ul className="errorMessage"></ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TdShiftCodeButtonView;
